module.exports = __webpack_public_path__ + "img/fxt_cart_illustration.b5cae4cc.svg";